// Lưu git credential (username + PAT/token) vào git credential helper của hệ thống
// (osxkeychain trên macOS, wincred trên Windows, v.v.) thông qua `git credential approve`.
//
// Dùng `git credential approve` thay vì gọi trực tiếp git-credential-osxkeychain
// để portable qua mọi platform và mọi credential helper user đã config.
//
// Quan trọng: token KHÔNG được ghi vào bất kỳ file Avatar nào — chỉ vào keychain.
// Caller chịu trách nhiệm KHÔNG log lại token sau khi nhận từ user.

import { spawnSync } from "node:child_process";

export interface StoreGitCredentialArgs {
  host: string;
  username: string;
  token: string;
  /** Default: "https" */
  protocol?: string;
}

export interface StoreGitCredentialResult {
  ok: boolean;
  error?: string;
}

/**
 * Gọi `git credential approve` để lưu credential vào system credential helper.
 * Protocol mặc định là "https". Trailing blank line trong payload là BẮT BUỘC
 * theo git-credential protocol spec.
 *
 * Return { ok: true } nếu exit 0, ngược lại { ok: false, error: string }.
 */
export function storeGitCredentialForHost(args: StoreGitCredentialArgs): StoreGitCredentialResult {
  const protocol = args.protocol ?? "https";

  // git-credential protocol: mỗi field một dòng, kết thúc bằng blank line
  const payload = [
    `protocol=${protocol}`,
    `host=${args.host}`,
    `username=${args.username}`,
    `password=${args.token}`,
    "", // blank line bắt buộc
  ].join("\n");

  const r = spawnSync("git", ["credential", "approve"], {
    input: payload,
    encoding: "utf8",
    stdio: ["pipe", "pipe", "pipe"],
  });

  if (r.status === 0) {
    return { ok: true };
  }

  const errMsg = (r.stderr || "").trim() || (r.error?.message ?? "git credential approve thất bại");
  return { ok: false, error: errMsg };
}
